module.exports = __webpack_public_path__ + "static/media/building.0112f8d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/building.svg
// module id = 519
// module chunks = 0